import { ClientIdentityType } from 'api/types/data';
import { useUser } from 'libs/providers';

export const useOwner = (): {
  ownerId: string;
  ownerType: 'Client' | 'LegalClient';
} => {
  const { client } = useUser();

  if (!client) {
    throw new Error('Client is not defined');
  }

  switch (client.type) {
    case ClientIdentityType.Client:
    case ClientIdentityType.ClientWithRepresentative:
      return {
        ownerId: client.id,
        ownerType: 'Client',
      };
    case ClientIdentityType.LegalClientRepresentative:
    default:
      return {
        ownerId: client.ownerId!,
        ownerType: 'LegalClient',
      };
  }
};
